import { selectIsLoading } from '@store/loaders'
import {
  ApiUsageActions,
  selectApiUsage,
  selectApiUsageError,
} from '@store/reducers/apiUsage'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

export const useApiUsage = () => {
  const dispatch = useDispatch()

  const usage = useSelector(selectApiUsage)
  const loading = useSelector(selectIsLoading('api_usage_fetch'))
  const error = useSelector(selectApiUsageError)

  const refetch = () => dispatch(ApiUsageActions.fetch())

  useEffect(() => {
    dispatch(ApiUsageActions.fetch())
  }, [dispatch])

  return { usage, loading, error, refetch }
}
